import { Injectable } from '@angular/core';
import { LoggerService } from 'src/app/core/logger.service';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  constructor(private loggerService: LoggerService) {}

  public getDateFromTerm(term: string): number {
    const termDateStrings = term.split('-');
    if (termDateStrings.length !== 3) {
      this.loggerService.error(`An invalid term received ${term}`);
    }
    return new Date(
      parseInt(termDateStrings[0], 10),
      parseInt(termDateStrings[1], 10) - 1, // js date months starts at 0
      parseInt(termDateStrings[2], 10),
    ).getTime();
  }
}
